import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { PRODUCT, questions } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="border-y-2 border-volt/25 bg-carbon" data-id="element-160" data-mp="30gxuvzkkxjnt">
      <div className="mx-auto max-w-page px-3 py-8 text-center sm:px-6 sm:py-10" data-id="element-161" data-mp="2vpzbus87i7gv">
        <Reveal data-id="element-162" data-mp="39hvy4fn71n5c">
          <h2 id="problema" className="mx-auto max-w-3xl font-display text-xl uppercase leading-[1.08] text-volt sm:text-3xl lg:text-4xl" data-id="element-163" data-mp="39hcrvw6won75">
            ¿Y si en lugar de aprender a prueba y error tuvieras una ruta clara
            desde el primer día?
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm font-bold text-white sm:text-base" data-id="element-164" data-mp="3egh46vp4n11p">
            Tienes las ganas de aprender un oficio. Pero probablemente también
            tengas muchas preguntas.
          </p>
        </Reveal>

        <ul className="mx-auto mt-4 grid max-w-4xl gap-2 sm:grid-cols-2" data-id="element-165" data-mp="1k4is8lzfnr24">
          {questions.map((q, i) => <Reveal key={q} as="li" delay={i * 0.03} className="flex items-center gap-2 rounded-lg border border-white/10 bg-night px-3 py-2.5 text-left text-[0.8rem] font-semibold text-white sm:text-sm" data-id="element-166" data-mp="jb0nfb52h28z" data-mpi={i}>
              <HelpCircleIcon size={16} className="flex-shrink-0 text-volt" strokeWidth={2.5} data-id="element-167" data-mp="x5bgu5s0dkld" />
              {q}
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} className="mx-auto mt-5 max-w-3xl" data-id="element-168" data-mp="170v27y8y50vv">
          <p className="text-[0.85rem] leading-snug text-steel sm:text-base" data-id="element-169" data-mp="1c2u4f4sy9rr8">
            El problema no siempre es la falta de información.{' '}
            <span className="font-bold text-white" data-id="element-170" data-mp="1g11j7u3usizs">
              Es que hay demasiada información dispersa y pocas rutas claras
              para el principiante.
            </span>
          </p>
          <p className="mt-2 text-[0.85rem] leading-snug text-steel sm:text-base" data-id="element-171" data-mp="3hwkb676jndes">
            {PRODUCT} reúne los conocimientos fundamentales en una secuencia
            diseñada para llevarte desde los conceptos básicos hasta el
            razonamiento inicial de una falla eléctrica.
          </p>
          <p className="mt-3 font-script text-2xl text-volt sm:text-3xl" data-id="element-172" data-mp="xym47nkqr60y">
            Aprende. Comprende. Practica. Avanza.
          </p>
        </Reveal>
      </div>
    </section>;
}